<template>
    <div class="c-car-selectcar ">
        <div class="component">
            <h3 class="text--upper">Wybierz pojazd</h3>
            <div class="c-car-selectcar__container">
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <TypeSelect :options="getModels"
                                :input="{ disabled: !getModels, placeholder: 'Model', sufix: '' }"
                                v-on:selectValue="lead.model_id = $event.id"
                                :filterFunction="(value, search) => String(value.name.toLowerCase()).includes(search.toLowerCase())">
                                <template slot-scope="{option}">{{ option.name }}</template>
                            </TypeSelect>
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <span class="input-placeholder" :class="{ 'compleeted': lead.registration_number }">Nr
                                rejestracyjny *</span>
                            <input type="text" name="registration_number" v-model="lead.registration_number">
                            <small class="text-error" v-if="!lead.registration_number">To pole jest wymagane</small>
                        </label>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <span class="input-placeholder" :class="{ 'compleeted': lead.vin }">Numer VIN</span>
                            <input type="text" name="vin" v-model="lead.vin" maxlength="17">
                            <span class="c-car-selectcar__wherevin">
                                <img src="@/assets/tooltip.svg" alt="Gdzie znajdę VIN?"
                                    class="c-car-selectcar__wherevin__info">
                                <div class="c-car-selectcar__wherevin__modal">
                                    <img src="@/assets/gdzie_jest_vin.svg" alt="Tu znajdziesz swój vin">
                                    <p>
                                        Numer VIN można znaleźć w dokumentach pojazdu oraz w zależności od kraju na
                                        <b>framudze
                                            drzwi</b> po stronie kierowcy lub pasażera lub w <b>dolnej części przedniej
                                            szyby po stronie
                                            kierowcy</b>.
                                    </p>
                                </div>
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="component">
            <div class="c-car-selectcar__container">
                <div class="flex-row">
                    <div class="flex-col">
                        <label class="mt--1">
                            <span class="input-placeholder" :class="{ 'compleeted': lead.mileage }">Stan licznika</span>
                            <input type="number" name="mileage" v-model="lead.mileage">
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-row flex-row--end">
            <router-link to="/overview">
                <button class="btn btn--primary" :disabled="!validation.car">Dalej do przeglądu</button>
            </router-link>
        </div>
    </div>
</template>
<script>
import lead from '@/mixins/lead.js'
import { mapActions, mapGetters } from 'vuex'

import TypeSelect from '../elements/type-select.vue'

export default {
    mixins: [lead],
    components: {
        TypeSelect
    },
    computed: {
        ...mapGetters({
            getModels: 'definitions/getModels'
        })
    },
    methods: {
        ...mapActions({
            fetchModels: 'definitions/fetchModels'
        })
    },
    mounted() {
        if (this.getModels.length < 1) {
            this.fetchModels();
        }
    }
}
</script>
<style lang="scss" scoped>
.c-car-selectcar {
    &__container {
        max-width: 1024px;
        margin: 0 auto;
    }

    &__wherevin {
        position: absolute;
        margin-top: -2.5rem;
        right: 0;
        text-align: right;
        z-index: 999;

        &__info {
            width: 2rem;
            height: auto;
            cursor: pointer;
        }

        $t: &;

        &__modal {
            width: 100%;
            min-width: 25vw;
            max-width: 300px;
            background-color: #fff;
            border: 1px solid #000;
            text-align: left;
            padding: 1rem;
            display: none;
        }

        &:hover {
            #{$t}__modal {
                display: block;
            }
        }
    }
}
</style>